<template>
  <Card>
    <p slot="title"> Tambah Omset</p>

    <Button :disabled="!isDataFilled" :loading="isSubmitButton" type="success" slot="extra" size="small"
      @click="actionPost">
      <span v-if="!isSubmitButton">Simpan Data</span>
      <span v-else>Sedang diproses.....</span>
    </Button>

    <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
      <Col span="4">
      <Date-picker v-model="omsetDate" style="width: 100%;" format="yyyy-MM-dd" placeholder="Pilih Tanggal">
      </Date-picker>
      </Col>

      <Col span="3" align="right">
      <p style="margin-top: 5px;">Max. 100 baris</p>
      </Col>
    </Row>

    <br />

    <div>
      <HotTable ref="hotTableComponent" :settings="hotSettings">
      </HotTable>
    </div>
  </Card>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import { HotTable } from '@handsontable/vue';
import { registerAllModules } from "handsontable/registry";

registerAllModules();

import "handsontable/dist/handsontable.full.min.css";

export default {
  components: { HotTable },
  data() {
    return {
      omsetDate: null,
      isDataFilled: false,
      isSubmitButton: false,
      hotSettings: {
        licenseKey: "non-commercial-and-evaluation",
        height: 600,
        width: "100%",
        stretchH: "all",
        filters: true,
        autoColumnSize: true,
        autoRowSize: true,
        colHeaders: true,
        rowHeaders: true,
        copyPaste: true,
        colWidths: [200, 150, 300, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150],
        colHeaders: [
          "CONTAINER NUMBER",
          // "BRANCH",
          "SUM OF VOL",
          "SUM OF UANG YG AKAN DITERIMA",
          "PIB",
          "NOTUL",
          "OPS PELABUHAN",
          "TRUCKING",
          "DAOP",
          "DEMURRAGE",
          "RE-EXPORT",
          "KAPAL/CONT. GZ",
          "FORM E",
          "LS"
        ],
        minRows: "100",
        columns: [
          {
            data: "containerNumber",
            type: "text",
          },
          // {
          //   data: "branch",
          //   type: "text",
          // },
          {
            data: "sumOfVol",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "sumOfUYAD",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "pib",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "notul",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "opsPort",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "trucking",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "daop",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "demurrage",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "reExport",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "shipContGZ",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "formE",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
          {
            data: "ls",
            type: "numeric",
            numericFormat: {
              pattern: "0,0",
            },
            className: "htRight"
          },
        ],
        beforeChange: (changes, source) => {
          if (changes && source === 'edit') {
            changes.forEach(change => {
              let [row, prop, oldValue, newValue] = change;

              if (prop === 'containerNumber' && typeof newValue === 'string') {
                change[3] = newValue.toUpperCase();
              }
            });
          }
        },
        afterChange: (changes) => {
          const hot = this.$refs.hotTableComponent.hotInstance;

          // handle submit button
          if (changes) {
            const isEmpty = (val) => val === null || val === "" || val === undefined;

            this.$nextTick(() => {
              const allData = hot.getData();

              const isAllNullOrEmpty = allData.every(row =>
                row.every(isEmpty)
              );

              if (!isAllNullOrEmpty) {
                this.isDataFilled = true;
              } else {
                this.isDataFilled = false;
              }
            });
          }
        },
      },
    }
  },
  methods: {
    actionPost() {
      // mandatory input date
      if (!this.omsetDate) {
        this.$Notice.warning({
          title: "Perhatian",
          desc: "Silahkan pilih tanggal terlebih dahulu !",
          duration: 3
        });

        return false
      }

      const hot = this.$refs.hotTableComponent.hotInstance;
      const allData = hot.getData();
      const isEmpty = (val) => val === null || val === "" || val === undefined;

      // hanya ambil row yg ada isinya
      const dataFilled = allData.filter(row => !row.every(isEmpty));

      // langsung mapping ke payload
      const bundle = dataFilled.map(data => ({
        containerNumber: data[0],
        // branch: data[1],
        sumOfVol: data[1],
        sumOfUYAD: data[2],
        pib: data[3],
        notul: data[4],
        opsPort: data[5],
        trucking: data[6],
        daop: data[7],
        demurrage: data[8],
        reExport: data[9],
        shipContGZ: data[10],
        formE: data[11],
        ls: data[12],
      }));

      const payload = {
        omsetDate: this.omsetDate,
        bundle: bundle
      }

      console.log({ payload });
      this.isSubmitButton = true
      HTTP
        .post('omset/create-bundle', { payload })
        .then(response => {
          console.log(response)

          this.$Message.success({
            content: 'Omset berhasil disimpan !',
            duration: 3
          });

          hot.loadData([]) // clear data
          this.isSubmitButton = false
        })
        .catch(e => {
          this.isSubmitButton = false
          this.$Notice.error({
            title: "Error",
            desc: e,
            duration: 5
          });
        })
    },
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// OmsetAdd.vue?df09df9a